/* eslint-disable react/react-in-jsx-scope */
/* eslint-disable react-hooks/rules-of-hooks */
import { useChecklistSummaryDrawer } from '@/components_v2/ChecklistSummary';
import { Task } from '@/gql/types';
import { Badge, Button, HStack, Tag, Text } from '@chakra-ui/react';
import { ColumnDef } from '@tanstack/react-table';
import moment from 'moment';
import { useTranslation } from 'react-i18next';

export const getTableColumns = () => {
  const { t } = useTranslation();
  const columns: ColumnDef<Task>[] = [
    {
      accessorKey: 'name',
      header: t('common.title'),
      cell({ getValue, row }) {
        const { openDrawer } = useChecklistSummaryDrawer();
        const { id } = row.original;
        return (
          <Button
            onClick={() =>
              openDrawer({
                id,
                type: 'task',
                refresh() {
                  //
                },
              })
            }
            size="lg"
            color="blue.600"
            variant="link"
          >
            <Text noOfLines={2}>{getValue()}</Text>
          </Button>
        );
      },
    },
    {
      header: t('common.email'),
      accessorKey: 'templateUrlEmail',
      cell({ getValue }) {
        const value = getValue<Task['templateUrlEmail']>();

        return <Text>{value ? value?.email : t('registrations.no_email')}</Text>;
      },
    },
    {
      accessorKey: 'status',
      cell() {
        const { t } = useTranslation();
        return (
          <HStack>
            <Tag size="md" colorScheme="green" variant="subtle">
              {t('registrations.finished_status')}
            </Tag>
          </HStack>
        );
      },
    },
    {
      accessorKey: 'flaggedCount',
      header: () => {
        const { t } = useTranslation();
        return t('tasks.header.flagged_items');
      },
      cell({ getValue }) {
        const { t } = useTranslation();
        const count = getValue<number>() || 0;

        const getColor = () => {
          if (count === 0) return 'green';
          if (count <= 3) return 'orange';
          return 'red';
        };

        return (
          <Badge rounded="sm" colorScheme={getColor()} variant="outline">
            {t('registrations.flagged_items_count', { count })}
          </Badge>
        );
      },
    },
    {
      accessorKey: 'member',
      header: t('columns.authorName'),
      cell({ getValue, cell }) {
        const value = getValue<Task['member']>();
        const { t } = useTranslation();
        return (
          <Text noOfLines={3}>
            {value?.fullName ||
              cell.row.original?.member?.fullName ||
              t('registrations.no_author')}
          </Text>
        );
      },
    },
    {
      accessorKey: 'templateTask',
      header: t('registrations.checklist'),
      cell({ getValue }) {
        const value = getValue<Task['templateTask']>();
        return <Text noOfLines={3}>{value?.formulary?.name}</Text>;
      },
    },
    {
      header: t('registrations.finished_at'),
      accessorKey: 'finishedAt',
      cell({ cell }) {
        const value = cell.getValue<number>();

        return value ? (
          <Text>{moment(new Date(Number(value))).calendar()}</Text>
        ) : (
          <></>
        );
      },
    },
  ];
  return columns;
};
